import { FormikProps } from "formik";
import { useContext, useMemo } from "react";
import {
  SubmitCreation,
  SubmitCreationFile,
} from "../../../../../generated/data-contracts";
import {
  AvisEditableList,
  editableTableActionWidth,
  IAvisEditableListFieldConfig,
  IRowState,
} from "../../../../shared/components/editableList";
import {
  AvisFileUpload,
  AvisSection,
} from "../../../../shared/components/form";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationNewFilesProps {
  bag: FormikProps<SubmitCreation>;
  bagField: keyof SubmitCreation;
  disabled: boolean;
  allowedFileFormats: string[] | undefined;
  textKey: string;
}
export function CreationNewFiles(props: Readonly<ICreationNewFilesProps>) {
  const { bag, bagField, disabled, allowedFileFormats, textKey } = props;
  const { res } = useContext(AvisContext);

  const fieldCollection: IAvisEditableListFieldConfig<
    IRowState<SubmitCreationFile>
  >[] = useMemo(
    () => [
      {
        name: "fileName",
        width: 280 + (disabled ? editableTableActionWidth : 0),
        renderField: (field, prefix, i, _val, onChange) => {
          return (
            <AvisFileUpload
              name={`${prefix}.${i}.${field.name}`}
              disabled={disabled}
              onChange={onChange}
              allowedFormats={allowedFileFormats}
            />
          );
        },
      },
    ],
    [allowedFileFormats, disabled],
  );

  return (
    <AvisSection
      title={res("authors_Creation_Section_Files_Title")}
      textToDisplayKey={textKey}
    >
      <AvisEditableList<SubmitCreation, SubmitCreationFile>
        bag={bag}
        bagField={bagField}
        initValue={{ fileName: "", base64Data: "" }}
        maxRows={5}
        fields={fieldCollection}
        disabled={disabled}
        view="table"
      />
    </AvisSection>
  );
}
